import useGetMySelf from "@/features/auth/use-get-my-self";

/**
 * 계정(user) 단위로 막힌 기능 코드.
 * 회사 단위 기능 플래그(company.features)와 달리, 같은 바이어에 연결된 계정끼리도 다르게 줄 수 있다.
 * 값은 어드민 회원 수정에서만 바꾼다.
 */
export const RESTRICTED_FEATURE_ORDER = "ORDER";

export default function useRestrictedFeatures() {
  const { data: mySelf, isLoading } = useGetMySelf();
  const restrictedFeatures = mySelf?.restrictedFeatures ?? [];

  return {
    restrictedFeatures,
    isOrderRestricted: restrictedFeatures.includes(RESTRICTED_FEATURE_ORDER),
    // 유저 정보가 오기 전에는 제한 여부를 알 수 없다 — 가드가 깜빡이지 않게 구분한다.
    isLoading: isLoading || !mySelf,
  };
}
